import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import { Radio } from 'lucide-react';
import { CountUp } from '../../components/CountUp.tsx';
import type { EventRow } from './landingData.ts';

interface Props {
  rows: EventRow[];
  eventCount: number;
}

export function LandingEventStream({ rows, eventCount }: Props) {
  const reduce = useReducedMotion();

  return (
    <div className="event-console">
      <div className="event-console-head">
        <Radio size={13} />
        <span>live controller stream</span>
        <div className="spacer" />
        <span className="streaming"><span />streaming</span>
      </div>

      <div className="event-console-list">
        <AnimatePresence initial={false}>
          {rows.map((row, index) => (
            <motion.div
              className="event-console-row"
              key={`${row.door}-${row.label}-${index}`}
              layout={!reduce}
              initial={reduce ? { opacity: 0 } : { opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={reduce ? { opacity: 0 } : { opacity: 0, height: 0 }}
              transition={reduce ? { duration: 0.15 } : { type: 'spring', stiffness: 420, damping: 34 }}
            >
              <span className="ts">{row.ts.padStart(3, ' ')}</span>
              <span className="door">
                {row.door}
                <span>{row.site}</span>
              </span>
              <span className={`ev ${row.kind}`}>{row.label}</span>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>

      <div className="event-console-foot">
        <span>events today</span>
        <strong><CountUp value={eventCount} locale duration={700} /></strong>
        <span className="divider" />
        <span>p50 relay</span>
        <strong>142ms</strong>
      </div>
    </div>
  );
}
